module.exports = __webpack_public_path__ + "static/media/3ds.b1159301.png";